import { ChangeEvent, FocusEvent } from 'react';

import { usStateCodes } from 'constants/states';

export * from './AnalyticsEvent';
export * from './Commands';
export * from './Details';
export * from './Status';
export * from './StepConfig';
export * from './Submit';
export * from './SubmitEdit';
export * from './Summary';
export * from './FieldData';
export * from './Validation';
export * from './DocumentSignature';
export * from './Features';
export * from './Properties';

export type Nullable<T> = T | null;
export type Optional<T> = T | undefined;
export type OptionalAndNullable<T> = T | null | undefined;
export type Voidable<T> = T | void;
export type SchemaType = {
  [key: string]: unknown;
};

export type InputOnChangeType = (event: ChangeEvent<HTMLInputElement>) => void;
export type InputOnFocusType = (event: FocusEvent<HTMLInputElement>) => void;
export type SelectOnChangeType = (
  event: ChangeEvent<HTMLSelectElement>
) => void;
export type TextFormat = 'lowercase' | 'capitalize' | 'uppercase';

export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;
export type WeekDayType = (typeof weekDays)[number];

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;
export type MonthType = (typeof months)[number];

export type StateCodeType = (typeof usStateCodes)[number];

export type Prettify<T> = {
  [K in keyof T]: T[K];
};

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
